import { deDE } from "@mui/material/locale";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";

const theme = responsiveFontSizes(
    createTheme({
        typography: {
            body1: {
                fontSize: 14
            }
        },
        palette: {
            primary: {
                dark: "#000000",
                main: "#000000",
                light: "#222222",
                contrastText: "rgba(255, 255, 255, 0.87)"
            },
            secondary: {
                dark: "#DDDDDD",
                main: "#FFFFFF",
                light: "#FFFFFF",
                contrastText: "rgba(0, 0, 0, 0.87)"
            },
            error: {
                main: "#D32F2F"
            },
            success: {
                main: "#388E3C"
            },
            info: {
                main: "#448AFF"
            },
            warning: {
                main: "#F57C00"
            },
            text: {
                primary: "rgba(0, 0, 0, 0.87)",
                secondary: "rgba(0, 0, 0, 0.60)",
                disabled: "rgba(0, 0, 0, 0.38)"
            },
            divider: "#E1E4E8",
            background: {
                default: "#FFFFFF",
                paper: "#F6F8FA"
            },
            mode: "light"
        }
    }, deDE)
);

export default theme;
